import React, { useContext, useState, useEffect } from "react";
import ModerationCountContext from "../context/ModerationCountContext";
import WsContext from "../context/WsContext";
import { TeaserModerationCountService } from "../utils/api";
import { canModerateAny } from "../utils/perm";
import usePermissions from "../hooks/usePermissions";
import { useConfig } from "../context/ConfigContext";

const ModerationCountProvider = ({ children }) => {
  const permissions = usePermissions();
  const [count, setCount] = useState({
    exchange: 0,
    goods: 0,
    media: 0,
    total: 0
  });
  const [loading, setLoading] = useState(true);
  const wsContext = useContext(WsContext);
  const { windowInFocus } = useConfig();

  const loadCount = () => {
    setLoading(true);

    TeaserModerationCountService()
      .then(data => {
        setCount(data.count);
      })
      .catch(e => {
        console.log(e);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (canModerateAny(permissions) && windowInFocus) {
      wsContext.eventEmitter.subscribe("teasers_update", loadCount);
      wsContext.eventEmitter.subscribe("moderation", loadCount);
      loadCount();
    }

    return () => {
      if (canModerateAny(permissions)) {
        wsContext.eventEmitter.unsubscribe("teasers_update", loadCount);
        wsContext.eventEmitter.unsubscribe("moderation", loadCount);
      }
    };
  }, [windowInFocus]);

  return (
    <ModerationCountContext.Provider value={{ count, loading }}>
      {children}
    </ModerationCountContext.Provider>
  );
};

export default ModerationCountProvider;
